import React from 'react'
import queryString from 'query-string'
import { useSchedulingDetails } from './hooks/useSchedulingDetails'
import { useLocation } from 'react-router-dom'
import { getCharts, STATUSES } from './constants'
import { functionalitiesHelper } from '../../../../utils/functionalitiesHelper'
import BackButton from '../../../../components/BackButton'
import BarChart from '../../../../components/BarChart'
import Card from '../../../../components/Card'
import { Button } from '../../../../components/Form'
import useGoTo from '../../../../hooks/useGoTo'
import CheckedAvatar from '../../../../assets/icons/checked-avatar.svg'
import MessageInfo from '../../../../pages/Professionals/Dashboard/components/MessageInfo'
import DateHeader from '../../../../pages/Professionals/Dashboard/components/DateHeader'
import * as S from './styles'

const SchedulingsDetails = () => {
  const { search } = useLocation()
  const { getDates } = functionalitiesHelper
  const goToPage = useGoTo()
  const { date, sameDate } = queryString.parse(search, { parseBooleans: true })
  const { in_progress: inProgress, scheduled } = STATUSES
  const { monthAndYear, day, fullDate } = getDates(date)
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const schedulingData = useSchedulingDetails(professional.id, fullDate, false, sameDate)
  const schedulingDetails = schedulingData ? getCharts(schedulingData) : []
  const overviewData = schedulingDetails?.schedulingOverview?.data
  const hasInProgressPreviousData = !!overviewData?.find(data => data.label === inProgress && data.value > 0)
  const hasScheduledPreviousData = !!overviewData?.find(data => data.label === scheduled && data.value > 0)
  const unfinishedData = {
    inProgress: hasInProgressPreviousData && !hasScheduledPreviousData,
    scheduled: hasScheduledPreviousData && !hasInProgressPreviousData,
    both: hasScheduledPreviousData && hasScheduledPreviousData
  }
  const hasUnfinishedPreviousData = !sameDate && (hasInProgressPreviousData || hasScheduledPreviousData)
  const loading = schedulingDetails.length === 0
  const actionButton = (
    <Button outline size='medium'
      onClick={() => goToPage('/dashboard/scheduling-details/status', `?date=${fullDate}&sameDate=${sameDate}`)}>
      Detalhes
    </Button>
  )
  const header = {
    title: monthAndYear,
    subtitle: `Informações até o dia ${day} ${sameDate ? 'deste mês' : ''}`,
    loading
  }
  return (
    <>
      <BackButton text='Detalhes dos atendimentos' backPage='/dashboard' paramData={`?date=${date}`} />
      <S.Container>
        <DateHeader {...header} />
        <S.CardWrapper>
          <Card full>
            <S.CardBody>
              <S.CardSection>
                <section>
                  <S.CardTitle>Histórico de atendimentos</S.CardTitle>
                  <S.CardSubtitle>Veja detalhes e informações de cada dia do mês</S.CardSubtitle>
                </section>
                <S.Avatar src={CheckedAvatar} />
              </S.CardSection>
              <S.ActionButton outline size='small' onClick={() => goToPage('/dashboard/scheduling-details/daily', `?date=${date}&sameDate=${sameDate}`)}>Detalhes</S.ActionButton>
            </S.CardBody>
          </Card>
        </S.CardWrapper>
        <BarChart {...schedulingDetails?.finishedTotal} maxColor loading={loading} />
        <BarChart {...schedulingDetails?.schedulingOverview} loading={loading} customBody={actionButton} breakLine />
        {
          hasUnfinishedPreviousData &&
          <S.WarningCard>
            <MessageInfo>
              Identificamos que existem atendimentos com status {
                unfinishedData.inProgress
                  ? <strong>{STATUSES.in_progress} </strong>
                  : unfinishedData.scheduled
                    ? <strong>{STATUSES.scheduled} </strong>
                    : <><strong>{STATUSES.in_progress} </strong> e <strong>{STATUSES.scheduled} </strong></>
              }
              em uma data passada. Sugerimos que verifique na recepção o que aconteceu.
            </MessageInfo>
          </S.WarningCard>
        }
      </S.Container>
    </>
  )
}

export default SchedulingsDetails
